/**
 * App footer rendered at the bottom of every page. Carries secondary
 * nav (About / Privacy / Cookies) plus the trademark + copyright line
 * for Time Back Solutions.
 *
 * Kept deliberately spartan so it doesn't compete with page content.
 * Policy / secondary nav lives here rather than in the top nav by
 * convention across the platform (see joltstream).
 */
export function AppFooter() {
  return (
    <footer className="app-footer">
      <nav className="app-footer-links" aria-label="Secondary">
        <a href="/about">About</a>
        <a href="/privacy">Privacy</a>
        <a href="/cookies">Cookies</a>
      </nav>
      <div className="app-footer-legal">
        <span>AskTogether&trade; is a trade mark of Time Back Solutions Ltd.</span>{' '}
        <span>&copy; 2026 Time Back Solutions Ltd. All rights reserved.</span>
      </div>
    </footer>
  );
}
